import axios from "axios";

export function createHttpClient({ getToken }) {
  const apiBaseUrl =
    process.env.REACT_APP_API_BASE_URL || "http://localhost:4000";

  const client = axios.create({
    baseURL: apiBaseUrl,
    headers: { "Content-Type": "application/json" },
  });

  client.interceptors.request.use((config) => {
    const token = getToken?.();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  });

  return client;
}

